//	P R O P S

export interface props___MdPoiViewModal {

	poi_id?: string | null,

}

//	S T A T E

export interface state___MdPoiViewModal {

	poi___id: string,
	poi___props: any | null,
	poi___props___address: string, 
	poi___props___isLoading: boolean, 

	poi___favorites___isLoading: boolean,

	poi_events___collection: any[],

}

//	S T A T E   D E F A U L T

export const state___MdPoiViewModal___default: state___MdPoiViewModal = {

	poi___id: '',
	poi___props: null,
	poi___props___address: '...', 
	poi___props___isLoading: true,

	poi___favorites___isLoading: false,

	poi_events___collection: [],

}